import { render, staticRenderFns } from "./ConsultaVentaCredito.vue?vue&type=template&id=13fd6ff8"
import script from "./ConsultaVentaCredito.vue?vue&type=script&lang=js"
export * from "./ConsultaVentaCredito.vue?vue&type=script&lang=js"
import style0 from "./ConsultaVentaCredito.vue?vue&type=style&index=0&id=13fd6ff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports